var _symbol;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-polygon",
    viewBox: "0 0 69 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.667 32l-30.022-28h60.045l-30.022 28z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a6abb9",
    style: {
      fill: "var(--color1, #a6abb9)"
    },
    d: "M28.25 2.5h-1.5v-2.5h-2.5v2.5h-16.5v-2.5h-2.5v2.5h-1.5c-2.068 0-3.75 1.682-3.75 3.75v22c0 2.068 1.682 3.75 3.75 3.75h24.5c2.068 0 3.75-1.682 3.75-3.75v-22c0-2.068-1.682-3.75-3.75-3.75zM29.5 28.25c0 0.689-0.561 1.25-1.25 1.25h-24.5c-0.689 0-1.25-0.561-1.25-1.25v-16.5h27v16.5zM29.5 9.25h-27v-3c0-0.689 0.561-1.25 1.25-1.25h1.5v2.5h2.5v-2.5h16.5v2.5h2.5v-2.5h1.5c0.689 0 1.25 0.561 1.25 1.25v3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.bb6937da2cdfc2650f8b5b48e210d1e1.svg";
export { ForwardRef as ReactComponent };